// Webpack Includes
import '../css/app.scss';

import Turbolinks from 'turbolinks';

// Global
import before from './initializers/before';
import common from './initializers/common';
import after from './initializers/after';

// Controllers
import academics from '@controllers/academics';
import checkout from '@controllers/checkout';
import home from '@controllers/home';
import store from '@controllers/store';

const init = () => {
  const app = {
    env: document.body.dataset.environment,
    controller: document.body.dataset.controller,
    action: document.body.dataset.action,
    $body: document.body
  };
  
  const controllers = {
    academics,
    checkout,
    home,
    store
  };
  
  before(app);
  common(app);
  
  if (controllers.hasOwnProperty(app.controller)) {
    if (controllers[app.controller].before) controllers[app.controller].before(app);
    if (controllers[app.controller][app.action]) controllers[app.controller][app.action](app);
    if (controllers[app.controller].after) controllers[app.controller].after(app);
  }
  
  after(app);
};

if (Turbolinks.supported && !document.body.dataset.isLivePreview) {
  // We're in an environment where Turbolinks will handle initialization and navigation.
  console.log('Using Turbolinks.');

  // Initial load should always `init`:
  document.addEventListener('turbolinks:load', init);

  Turbolinks.start();
  Turbolinks.setProgressBarDelay(250);

  // Set AJAXy header for Craft
  document.addEventListener('turbolinks:request-start', (e) => {
      e.data.xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  });

  // Subsequent requests/renders:
  document.addEventListener('turbolinks:render', (e) => {
      // Fire Google events, etc...
  });
} else {
  // We either can't rely on Turbolinks, or can expect Craft's live preview mode to replace the entire HTML document, and re-execute all scripts. Just initialize.
  console.log('Cold start.');

  init();
}

